import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Book, FileText, Gamepad2, Languages, ScrollText } from 'lucide-react';
const features = [{
  icon: <Book className="text-brand-blue" size={28} data-id="element-227" />,
  title: "eBook 'IA Fácil y Práctica' (43 páginas)",
  desc: 'Guía paso a paso desde cero. Lectura amena y directa al grano.'
}, {
  icon: <FileText className="text-brand-orange" size={28} data-id="element-228" />,
  title: 'Manual del Prompt Maestro',
  desc: "Plantillas de 'copiar y pegar' para tareas y planificación."
}, {
  icon: <Gamepad2 className="text-brand-yellow" size={28} data-id="element-229" />,
  title: '15 Dinámicas de Juego',
  desc: 'Actividades para aprender IA jugando en familia o en el aula.'
}, {
  icon: <Languages className="text-green-500" size={28} data-id="element-230" />,
  title: 'Diccionario IA-Español',
  desc: '30 términos técnicos explicados con peras y manzanas.'
}, {
  icon: <ScrollText className="text-purple-500" size={28} data-id="element-231" />,
  title: 'Contrato de Honor Familiar',
  desc: 'Un documento listo para imprimir y firmar con tus hijos sobre el uso ético.'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function WhatYouGet() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-232">
      <div className="max-w-5xl mx-auto" data-id="element-233">
        <div className="text-center mb-12" data-id="element-234">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-235">
            Todo lo que incluye tu acceso
          </h2>
          <p className="text-lg text-brand-text max-w-2xl mx-auto" data-id="element-236">
            Un kit completo diseñado para darte resultados inmediatos, sin
            relleno.
          </p>
        </div>

        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-237">
          {features.map((feature, index) => <motion.div key={index} variants={item} className={`bg-cream-50 rounded-2xl p-6 border border-cream-200 hover:-translate-y-1 transition-transform duration-300 shadow-sm hover:shadow-soft ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-238">
              <div className="bg-white w-14 h-14 rounded-xl flex items-center justify-center shadow-sm mb-5 border border-cream-100" data-id="element-239">
                {feature.icon}
              </div>
              <h3 className="font-bold text-lg text-brand-dark mb-2 leading-tight" data-id="element-240">
                {feature.title}
              </h3>
              <p className="text-brand-text text-sm leading-relaxed" data-id="element-241">
                {feature.desc}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}